import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const FORECAST_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Forecast.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const FORECAST_CONFIG = {
  entityName: 'Forecast',
  localizationKey: 'Controlling::Entity.Forecast',
  fields: FORECAST_FIELDS,
  permission: 'ControllingLiquidations.Forecasts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
